import { FaUserCircle } from "react-icons/fa";
import { Area, AreaContainer, Header, Wrapper } from "./index.styled";
import { Text } from "../common/text/text";
import { useState } from "react";
import { useTheme } from "styled-components";
import useOnclickOutside from "react-cool-onclickoutside";

export interface UserInfosProps {
  username: string;
  corporate: string;
}

export const UserInfos: React.FC<UserInfosProps> = ({
  username,
  corporate,
}) => {
  const [showDetail, setShowDetail] = useState(false);
  const theme = useTheme();
  const ref = useOnclickOutside(() => {
    setShowDetail(false);
  });
  return (
    <Wrapper>
      <FaUserCircle onClick={() => setShowDetail(!showDetail)} size={30} />
      <AreaContainer>
        <Area isShown={showDetail} ref={ref}>
          <Header>
            <FaUserCircle
              onClick={() => setShowDetail(!showDetail)}
              size={80}
              color={theme.colors.secondaryBlue.main}
            />
            <Text as="p" margin="0" color={theme.colors.secondaryBlue.main}>
              <b>{username}</b>
            </Text>
            <Text as="p" margin="0" color={theme.colors.secondaryBlue.main}>
              <b>{corporate}</b>
            </Text>
          </Header>
        </Area>
      </AreaContainer>
    </Wrapper>
  );
};
